import { getSiteType } from '../../../utils/SiteTypes';
import type { BaseLocation } from './BaseLocation';
import { BaseLocationEvent } from './BaseLocationEvent';
import type { GoodsByCategory } from './GoodsByCategory';
import type { LocationExternalSource } from './LocationExternalSource';
import type { SimpleArtist } from './SimpleArtist';
import type { SimpleMember } from './SimpleMember';
import type { Tweet } from './Tweet';

export class LocationEvent extends BaseLocationEvent {
  private readonly _posterImageUrls: string[];
  private readonly _goodsGiftTypes: string[];
  private readonly _goodsByCategory: GoodsByCategory;
  private readonly _location: BaseLocation;
  private readonly _tweet?: Tweet;
  private readonly _externalSource?: LocationExternalSource;

  constructor(
    eventId: string,
    name: string,
    locationId: string,
    startDate: Date,
    endDate: Date,
    category: string,
    status: string,
    countryEmoji: string,
    countryName: string,
    goodsNames: string[],
    artist: SimpleArtist,
    members: SimpleMember[],
    baseImageUrl: string,
    organizerTwitterId: string,
    posterImageUrls: string[],
    goodsGiftTypes: string[],
    goodsByCategory: GoodsByCategory,
    tweet: Tweet | undefined,
    location: BaseLocation,
    description: string,
    externalSource?: LocationExternalSource
  ) {
    super(
      eventId,
      name,
      locationId,
      [locationId],
      startDate,
      endDate,
      category,
      status,
      countryEmoji,
      countryName,
      goodsNames,
      artist,
      members,
      baseImageUrl,
      organizerTwitterId,
      description
    );
    this._posterImageUrls = posterImageUrls;
    this._goodsGiftTypes = goodsGiftTypes;
    this._goodsByCategory = goodsByCategory;
    this._location = location;
    this._tweet = tweet;
    this._externalSource = externalSource;
  }

  get posterImageUrls(): string[] {
    return [...this._posterImageUrls];
  }

  get goodsGiftTypes(): string[] {
    return [...this._goodsGiftTypes];
  }

  get goodsByCategory(): GoodsByCategory {
    return this._goodsByCategory;
  }

  get tweet(): Tweet | undefined {
    return this._tweet;
  }

  get location(): BaseLocation {
    return this._location;
  }

  get externalSource(): LocationExternalSource | undefined {
    return this._externalSource;
  }

  public hasGoodsGiftTypes(goodsGiftType: string): boolean {
    return this._goodsGiftTypes.includes(goodsGiftType);
  }

  public get luckyGiftTypes(): string[] {
    return this._goodsGiftTypes.filter((g) =>
      ['gacha', 'random', 'lucky_draw', 'lucky_number'].includes(g)
    );
  }

  public get etcGiftTypes(): string[] {
    return this._goodsGiftTypes.filter((g) =>
      ['hashtag', 'photobooth', 'small_exhibition'].includes(g)
    );
  }

  // public getSiteTypeIcon(): React.ComponentType<React.SVGProps<SVGSVGElement>> | undefined {
  //   switch (this.category) {
  //     case 'birthday_cafe':
  //       return BirthdayCafeIcon;
  //     case 'exhibition':
  //       return ExhibitionIcon;
  //     case 'filming_location':
  //       return FilmingLocationIcon;
  //     case 'foodie_spot':
  //       return FoodieSpotIcon;
  //     case 'billboard_ad':
  //       return BillboardAdIcon;
  //     case 'landmark':
  //       return LandmarkIcon;
  //     default:
  //       return undefined;
  //   }
  // }

  public getSiteName(): string | undefined {
    return getSiteType(this.category).name;
  }
}
